export default "__VITE_ASSET__BkjCM2BO__"